/*
 * @Description: 
 * @Author: beiweiping
 * @Date: 2019-07-10 17:13:32
 * @LastEditTime: 2020-03-25 10:35:25
 * @LastEditors: 陆伟
 */

function URLCONFIG(w) {
  var hostname = w.location.hostname
  var y = hostname.split('.')[0]

  if (y == 't') { // 测试环境 vpc
    w.globalConfig = {
      "headLineBathPath":"t.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc-al-dev.yunjiglobal.com",
      "orderAfterBasePath": "orderafter-al-dev.yunjiglobal.com",
      "ysappItemBasePath": "ys-dev.yunjiglobal.com",
      "itemBasePath": "item-dev.yunjiglobal.com",
      "dataBasePath": "t.yunjiglobal.com",
      "recruitBasePath": "t.yunjiglobal.com",
      "groupBasePath": "t.yunjiglobal.com",
      "activeBasePath": "www.wwb163.com",
      "picBasePath": "t.yunjiglobal.com",
      "ticketPayBasePath": "t.yunjiglobal.com",
      "ticketTripBasePath": "trip-dev.yunjiglobal.com",
      "newBornBasePath": "item-t.yunjiglobal.com",
      "yunjimarketingapp":"marketing-dev.yunjiglobal.com",
      'yunjioperateBasePath':'operate-dev.yunjiglobal.com',
      "specialBasePath":'special-al-dev.yunjiglobal.com',
      "environment": "dev",
      "testMode": "no",
      "orderBasePath":"order-dev.yunjiglobal.com/",
      "shareLife": "t.yunjiglobal.com",
      "shareLife": "t.yunjiglobal.com",
      "ticketPayPopularPath": "t.yunjiglobal.com",
      "ticketTripPopularPath": "trip-dev.yunjiglobal.com",
      "searchLinkPath": "search-dev.yunjiglobal.com",
      "userPath":"user-al-dev.yunjiglobal.com",  
      "wxcallback": "t-do-dev.yunjiglobal.com"
    }
  } else if (y === 'txst' || y === 'm-tx') { // 测试环境 腾讯云
    w.globalConfig = {
      "headLineBathPath":"txst.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc-tx.yunjiglobal.com",
      "orderAfterBasePath": "orderafter-tx.yunjiglobal.com",
      "ysappItemBasePath": "ys-txst.yunjiglobal.com",
      "rewardAppBasePath": "reward-txst.yunjiglobal.com",
      "itemBasePath": "item-txst.yunjiglobal.com",
      "dataBasePath": "txst.yunjiglobal.com",
      "recruitBasePath": "txst.yunjiglobal.com",
      "groupBasePath": "txst.yunjiglobal.com",
      "activeBasePath": "www.wwb163.com",
      "picBasePath": "txst.yunjiglobal.com",
      "ticketPayBasePath": "txst.yunjiglobal.com",
      "ticketTripBasePath": "txst.yunjiglobal.com",
      "newBornBasePath": "item-txst.yunjiglobal.com",
      "yunjimarketingapp":"marketing-txst.yunjiglobal.com",
      'yunjioperateBasePath':'txst.yunjiglobal.com',
      "specialBasePath":'lb-tx.yunjiglobal.com',
      "environment": "dev",
      "testMode": "no",
      "orderBasePath":"order-txst.yunjiglobal.com/",
      "shareLife": "txst.yunjiglobal.com",
      "ticketPayPopularPath": "txst.yunjiglobal.com",
      "ticketTripPopularPath": "txst.yunjiglobal.com",
      "userPath":"user-txst.yunjiglobal.com",
      "searchLinkPath": "search-txst.yunjiglobal.com",
      "shareLife": "txst.yunjiglobal.com",     
      "wxcallback": "t-do-dev.yunjiglobal.com"
    }
  } else if (y == 'st') { // 测试环境 压测
    w.globalConfig = {
      "yjbuyerPath":"t-do-dev.yunjiglobal.com",
      "headLineBathPath":"st.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc-st.yunjiglobal.com",
      "itemBasePath": "st.yunjiglobal.com",
      "dataBasePath": "st.yunjiglobal.com",
      "recruitBasePath": "st.yunjiglobal.com",
      "groupBasePath": "st.yunjiglobal.com",
      "activeBasePath": "st.yunjiglobal.com",
      "picBasePath": "172.16.0.6:8106",
      "orderAfterBasePath": "orderafter-st.yunjiglobal.com",
      "ysappItemBasePath": "ys-st.yunjiglobal.com",
      "ticketPayBasePath": "st.yunjiglobal.com",
      "ticketTripBasePath": "st.yunjiglobal.com",
      "newBornBasePath": "st.yunjiglobal.com",
      "yunjimarketingapp":"marketing.yunjiglobal.com",
      'yunjioperateBasePath':'operate-st.yunjiglobal.com',
      "specialBasePath":'spe.yunjix.com',
      "environment": "stresstest",
      "testMode": "no",
      "orderBasePath":"order-st.yunjiglobal.com/",
      "shareLife": "p.yunjiglobal.com",
      "ticketPayPopularPath": "st.yunjiglobal.com",
      "ticketTripPopularPath": "st.yunjiglobal.com",
      "searchLinkPath": "search-st.yunjiglobal.com",
      "userPath":"st.yunjiglobal.com",     
      "wxcallback": "t-do-dev.yunjiglobal.com"
    }
  }else if(y == 't-do-dev'){ // docker 环境
    w.globalConfig = {
      "yjbuyerPath":"t-do-dev.yunjiglobal.com",
      "headLineBathPath":"t-do-dev.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc-do-dev.yunjiglobal.com",
      "orderAfterBasePath": "orderafter-do-dev.yunjiglobal.com",
      "ysappItemBasePath": "t-do-dev.yunjiglobal.com",
      "rewardAppBasePath": "reward-do-dev.yunjiglobal.com",
      "itemBasePath": "item-do-dev.yunjiglobal.com",
      "dataBasePath": "t-do-dev.yunjiglobal.com",
      "recruitBasePath": "t-do-dev.yunjiglobal.com",
      "groupBasePath": "t-do-dev.yunjiglobal.com",
      "activeBasePath": "www.wwb163.com",
      "picBasePath": "t-do-dev.yunjiglobal.com",
      "ticketPayBasePath": "t-do-dev.yunjiglobal.com",
      "ticketTripBasePath": "trip-do-dev.yunjiglobal.com",
      "newBornBasePath": "item-do-dev.yunjiglobal.com",
      "yunjimarketingapp":"marketing-do-dev.yunjiglobal.com",
      'yunjioperateBasePath':'operate-do-dev.yunjiglobal.com',
      "specialBasePath":'spe.yunjix.com',
      "environment": "dev",
      "testMode": "no",
      "orderBasePath":"order-do-dev.yunjiglobal.com/",
      "shareLife": "t-do-dev.yunjiglobal.com",  
      "searchLinkPath": "search-do-dev.yunjiglobal.com",
      "userPath":"user-do-dev.yunjiglobal.com",
      "wxcallback": "t-do-dev.yunjiglobal.com" 
    }
  } else if (y == 'm' || y == 'r' || y == 'merchantrecruit') {  // 现网环境
    w.globalConfig = {
      "yjbuyerPath":"m.yunjiglobal.com",
      "headLineBathPath":"headline.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc.yunjiglobal.com",
      "itemBasePath": "item.yunjiglobal.com",
      "dataBasePath": "data.yunjiweidian.com",
      "recruitBasePath": "r.yunjiglobal.com",
      "groupBasePath": "p.yunjiglobal.com",
      "activeBasePath": "www.tao0715.com",
      "picBasePath": "pic.yunjiweidian.com",
      "orderAfterBasePath": "orderafter.yunjiglobal.com",
      "ysappItemBasePath": "ys.yunjiglobal.com",
      "rewardAppBasePath": "reward.yunjiglobal.com",
      "ticketPayBasePath": "pay.yunjiglobal.com",
      "ticketTripBasePath": "trip.yunjiglobal.com",
      "newBornBasePath": "item.yunjiglobal.com",
      "yunjimarketingapp":"marketing.yunjiglobal.com",
      'yunjioperateBasePath':'yunjioperate.yunjiglobal.com',
      "specialBasePath":'spe.yunjix.com',
      "environment": "idc",
      "testMode": "no",
      "orderBasePath":"order.yunjiglobal.com/",
      "shareLife": "merchantrecruit.yunjiglobal.com",
      "ticketPayPopularPath": "pay.yunjiglobal.com",
      "ticketTripPopularPath": "trip.yunjiglobal.com",
      "userPath":"user.yunjiglobal.com",
      "searchLinkPath": "search.yunjiglobal.com",
      "shareLife": "merchantrecruit.yunjiglobal.com",  
      "wxcallback": "wxcallback.yunjiglobal.com"    
    }
  } else if (y == 'm-ga' || y == 'r-ga' || y == 'merchantrecruit-al-ga') { // 现网预发布环境 gamma
    w.globalConfig = {
      "yjbuyerPath":"m-ga.yunjiglobal.com",
      "headLineBathPath":"headline-ga.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "sc-ga.yunjiglobal.com",
      "itemBasePath": "item-ga.yunjiglobal.com",
      "dataBasePath": "data.yunjiweidian.com",
      "recruitBasePath": "r.yunjiglobal.com",
      "recruitBasePathGa": "r-ga.yunjiglobal.com",
      "groupBasePath": "p.yunjiglobal.com",
      "activeBasePath": "www.tao0715.com",
      "picBasePath": "pic.yunjiweidian.com",
      "orderAfterBasePath": "orderafter-ga.yunjiglobal.com",
      "ysappItemBasePath": "ys-ga.yunjiglobal.com",
      "rewardAppBasePath": "reward-ga.yunjiglobal.com",
      "ticketPayBasePath": "pay.yunjiglobal.com",
      "ticketTripBasePath": "trip.yunjiglobal.com",
      "newBornBasePath": "item-ga.yunjiglobal.com",
      "yunjimarketingapp":"marketing-ga.yunjiglobal.com",
      'yunjioperateBasePath':'yunjioperate-ga.yunjiglobal.com',
      "specialBasePath":'spe.yunjix.com',
      "environment": "idc",
      "testMode": "no",
      "orderBasePath":"order-ga.yunjiglobal.com/",
      "shareLife": "merchantrecruit-al-ga.yunjiglobal.com",
      "ticketPayPopularPath": "pay.yunjiglobal.com",
      "ticketTripPopularPath": "trip.yunjiglobal.com",
      "searchLinkPath": "search-ga.yunjiglobal.com",
      "userPath":"user-ga.yunjiglobal.com",
      "wxcallback": "wxcallback.yunjiglobal.com"    
    }
  } else if (y =='local') { // 开发环境
    w.globalConfig = {
      "yjbuyerPath":"t-do-dev.yunjiglobal.com",
      "headLineBathPath":"local.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "local.yunjiglobal.com",
      "orderAfterBasePath": "local.yunjiglobal.com",
      "ysappItemBasePath": "local.yunjiglobal.com",
      "rewardAppBasePath": "local.yunjiglobal.com",
      "itemBasePath": "local.yunjiglobal.com",
      "dataBasePath": "local.yunjiglobal.com",
      "recruitBasePath": "local.yunjiglobal.com",
      "groupBasePath": "local.yunjiglobal.com",
      "activeBasePath": "www.wwb163.com",
      "picBasePath": "local.yunjiglobal.com",
      "ticketPayBasePath": "local.yunjiglobal.com",
      "ticketTripBasePath": "local.yunjiglobal.com",
      "newBornBasePath": "local.yunjiglobal.com",
      "yunjimarketingapp":"local.yunjiglobal.com",
      'yunjioperateBasePath':'local.yunjiglobal.com',
      "specialBasePath":'local.yunjiglobal.com',
      "environment": "dev",
      "testMode": "no",
      "orderBasePath":"local.yunjiglobal.com/",
      "shareLife": "local.yunjiglobal.com",
      "shareLife": "local.yunjiglobal.com",
      "ticketPayPopularPath": "local.yunjiglobal.com",
      "ticketTripPopularPath": "local.yunjiglobal.com",
      "userPath":"local.yunjiglobal.com",
      "searchLinkPath": "local.yunjiglobal.com",
      "linkBasePath":"local.yunjiglobal.com",
      "wxcallback": "t-do-dev.yunjiglobal.com" 
    }
  } else {    //  开发环境
    w.globalConfig = {
      "yjbuyerPath":"t-do-dev.yunjiglobal.com",
      "buyerBasePath": hostname + "/api-buyer",
      "linkBasePath": "v.yunjiglobal.com/api",
      "headLineBathPath": "t.yunjiglobal.com",
      "staticSubjectBasePath": "/yj/subject",
      "shoppingCircleUrlBuyer": "v.yunjiglobal.com/sc-api",
      "orderAfterBasePath": "orderafter-local.yunjiglobal.com",
      "ysappItemBasePath": "v.yunjiglobal.com/ys-api",
      "rewardAppBasePath": "v.yunjiglobal.com/api",
      "itemBasePath": "v.yunjiglobal.com/api",
      "dataBasePath": "local.yunjiweidian.org",
      "recruitBasePath": "v.yunjiglobal.com/api",
      "groupBasePath": "t.yunjiglobal.com",
      "activeBasePath": "www.wwb163.com",
      "picBasePath": "172.16.0.6:8106",
      "ticketPayBasePath": "v.yunjiglobal.com/api",
      "ticketTripBasePath": "v.yunjiglobal.com/api",
      "newBornBasePath": "t.yunjiglobal.com",
      "yunjioperateBasePath":'v.yunjiglobal.com/api',
      "specialBasePath":'special-al-dev.yunjiglobal.com',
      "yunjimarketingapp":"v.yunjiglobal.com/api",
      "environment": "local",
      "testMode": "yes",
      "orderBasePath":"order-txst.yunjiglobal.com/",
      "shareLife": "share.yunjiglobal.com/api/",
      "ticketPayPopularPath": "v.yunjiglobal.com/api",
      "ticketTripPopularPath": "v.yunjiglobal.com/api",
      "linkPopularPath": "v.yunjiglobal.com/api",
      "searchLinkPath":"v.yunjiglobal.com/search-api",
      "userPath":"v.yunjiglobal.com/api",
      "wxcallback": "t-do-dev.yunjiglobal.com" 
    }
  }

  if (w.globalConfig.environment != 'local') {
    w.globalConfig.buyerBasePath = w.globalConfig.linkBasePath = w.globalConfig.linkPopularPath = hostname
  }
}

URLCONFIG(window)
